import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

export default function Error404() {
  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Box>
        {/* Icon */}
        <Box
          sx={{
            mb: 2,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 96,
            height: 96,
            borderRadius: "50%",
            bgcolor: "error.light",
            color: "error.main",
          }}
        >
          <ErrorOutlineRoundedIcon sx={{ fontSize: 56 }} />
        </Box>

        {/* 404 Text */}
        <Typography
          sx={{
            fontSize: { xs: 56, sm: 72 },
            fontWeight: 900,
            lineHeight: 1,
            color: "text.primary",
          }}
        >
          404
        </Typography>

        <Typography
          sx={{
            mt: 1,
            fontSize: { xs: 20, sm: 24 },
            fontWeight: 700,
          }}
        >
          Page Not Found
        </Typography>

        <Typography
          sx={{
            mt: 1,
            color: "text.secondary",
            fontSize: 14,
            maxWidth: 420,
            mx: "auto",
          }}
        >
          The page you’re looking for doesn’t exist or may have been moved.
          Please check the URL or return to the homepage.
        </Typography>

        {/* Actions */}
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: 1.5,
            flexWrap: "wrap",
          }}
        >
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            startIcon={<HomeRoundedIcon />}
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Go to Home
          </Button>

          <Button
            component={RouterLink}
            to="/contact"
            variant="outlined"
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Contact Support
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
